import axios from "axios";

// Audio-call records are stored on the local Emergent backend (the external
// SoccorsoGC backend can't be updated from here), same pattern as AIS.
const BASE =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

export async function recordCall(rec, audioBlob) {
  try {
    if (!rec || !rec.event_id) return;
    let audio_path = null;
    if (audioBlob && audioBlob.size > 0) {
      try {
        const fd = new FormData();
        fd.append("file", audioBlob, `call_${rec.event_id}_${Date.now()}.webm`);
        const { data } = await axios.post(`${BASE}/api/upload/audio`, fd);
        audio_path = (data && data.path) || null;
      } catch (e) { console.debug("upload audio fallito", e); }
    }
    await axios.post(`${BASE}/api/calls`, { ...rec, audio_path });
  } catch (e) { console.debug("recordCall fallito", e); }
}

export async function fetchCalls() {
  const { data } = await axios.get(`${BASE}/api/calls`);
  return data?.calls || [];
}
